import styled from '@emotion/styled';
import { Trans } from '@lingui/react/macro';
import React from 'react';
import useGameInfo from 'modules/overlay-v2/ui/hooks/use-game-info';
import Block from '../components/block';
import AppText from '../components/text';
import { theme } from 'styles/theme/theme';

interface IProps {
  teamIndex: number;
}

function Team(props: IProps) {
  const { teams } = useGameInfo();
  const { teamIndex } = props;
  const team = teamIndex === 0 ? teams?.first : teams?.second;

  const headers = (
    <TeamMembers>
      <Text color={theme.colors.Gray} size={'small'} style={{ width: sizes.number }}>
        <Trans>Номер</Trans>
      </Text>
      <Text color={theme.colors.Gray} size={'small'} style={{ width: sizes.name }}>
        <Trans>Имя</Trans>
      </Text>
      <Text color={theme.colors.Gray} size={'small'} style={{ width: sizes.goals }}>
        <Trans>Гол</Trans>
      </Text>
      <Text color={theme.colors.Gray} size={'small'} style={{ width: sizes.yellowCards }}>
        <Trans>ЖК</Trans>
      </Text>
      <Text color={theme.colors.Gray} size={'small'} style={{ width: sizes.redCards }}>
        <Trans>КК</Trans>
      </Text>
    </TeamMembers>
  );

  const members = team?.members?.map((member) => (
    <TeamMembers key={member.id}>
      <Substrate color={theme.colors.WhiteGray} style={{ width: sizes.number }}>
        <Text color={theme.colors.SurfaceWhite} size={'medium'}>
          {member.number}
        </Text>
      </Substrate>
      <Text
        color={member.isInvolved ? theme.colors.AccentNaplesYellow : theme.colors.SurfaceWhite}
        size={'medium'}
        style={{ width: sizes.name }}
      >
        {`${member.name} ${member.surname} ${member.middleName}`}
      </Text>
      <Substrate color={theme.colors.WhiteGray} style={{ width: sizes.goals }}>
        <Text color={theme.colors.SurfaceWhite} size={'medium'}>
          {member.qtyGoalsMatch}
        </Text>
      </Substrate>
      <Substrate color={theme.colors.AccentNaplesYellow} style={{ width: sizes.yellowCards }}>
        <Text color={theme.colors.SurfaceWhite} size={'medium'}>
          {member.qtyYellowCardsMatch}
        </Text>
      </Substrate>
      <Substrate color={'#AB138A'} style={{ width: sizes.redCards }}>
        <Text color={theme.colors.SurfaceWhite} size={'medium'}>
          {member.qtyRedCardsMatch}
        </Text>
      </Substrate>
    </TeamMembers>
  ));

  return (
    <Block className={'flex-center flex-col'}>
      <Text color={theme.colors.SurfaceWhite} size={'large'}>
        {team?.name}
      </Text>
      {headers}
      {members}
    </Block>
  );
}

export default Team;

const sizes = {
  number: '15%',
  name: '40%',
  goals: '15%',
  yellowCards: '15%',
  redCards: '15%',
};

const TeamMembers = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  width: 100%;
`;

const Text = styled(AppText)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Substrate = styled.div<{ color: string }>`
  height: 16px;
  background-color: ${({ color }) => color};
  display: flex;
  justify-content: center;
  align-items: center;
`;
